// Plugins

// Local
import initUitKit from "./ui-kit.js";
import ProductDetailCarousel from "./modules/product/product-detail-carousel";
import ProductList from "./modules/product-category/product-list";
import StepList from "./partials/step-list";

window.initDom = ($wrapper) => {
    initUitKit($wrapper);

    $wrapper.querySelectorAll('[data-product-detail-carousel]').forEach($el => (new ProductDetailCarousel($el)));
    $wrapper.querySelectorAll('[data-block-type="block-product-list"]').forEach($el => (new ProductList($el)));
    $wrapper.querySelectorAll('[data-step-list]').forEach($el => (new StepList($el)));

}

(function() {
    window.initDom(document);
})();
